import React, { useState, useEffect } from "react";
import { Redirect } from 'react-router-dom'
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Container from "@material-ui/core/Container";
import Hidden from '@material-ui/core/Hidden';
import Skeleton from '@material-ui/lab/Skeleton';
import {
    getUSN, 
    generatePage_no_USN_URI,
    generatePageURI,    
    headerAPI,
    pagePaths,
    prefixURI,
    weaponsAPI,
    profileAPI,
    _link,
    CDN_URI
} from '../common/utilities';
import moment from 'moment';
import styles from './collectionleadersPage.module.css';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SubPageTemplate from "./templates/SubPageTemplate";
import { pageHeaderData } from "./sampleData/sampleData";
import { MuiThemeProvider, createMuiTheme, useTheme  } from "@material-ui/core/styles";
import ReactImageFallback from "react-image-fallback";
import { Translation, Trans } from "react-i18next";
import axios from "axios";
import { ThemeProvider } from '@material-ui/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const LB_API_RSLT_DATE_FORMAT = "YYYY/MM/DD HH:mm:ss.SSS";

class CurrentPlayerInfoBox extends React.Component{

	constructor(props){
        super(props);
    }

    render(){

        if(this.props.signedIn){

            if(this.props.player && this.props.player.last_Item_Date){

                return(
                    <Grid item xs={12} sm={12} md={12} lg={4} xl={4} style={{marginTop: '26px', paddingBottom: '0'}}>
                        <RankedPlayer player = {this.props.player} usn={this.props.player.usn} currentUser={true} />
                    </Grid>
                );                
            }else{
                return(
                    <Grid item xs={12} sm={12} md={12} lg={4} xl={4} style={{marginTop: '26px', paddingBottom: '0'}}>
                        <UnrankedMessageBox signedIn = {this.props.signedIn} />
                    </Grid>
                );                
            }
        }else{
            return(
                <Grid item xs={12} sm={12} md={12} lg={4} xl={4} style={{marginTop: '26px', paddingBottom: '0'}}>
                    <UnrankedMessageBox signedIn = {this.props.signedIn} />
                </Grid>
            );
        }
    }
}

class UnrankedMessageBox extends React.Component{

	constructor(props){
        super(props);
    }

    render(){
        var mySigninURL = `${_link['z8_login_url_ssl']}?returnurl=${window.location.href}`;
        var signInMessage = <p><Trans>Please <a href={mySigninURL}>sign in</a> to view your rank</Trans></p>;
        var StartCollectingMessage = <p><Trans>Complete the collection to see where you rank</Trans></p>;

        var message = (this.props && this.props.signedIn) ? StartCollectingMessage : signInMessage;
        return(
            <div className={styles.collectionNotRankedBox}>
                {message}
            </div>
        );        
    }
}

class RankedPlayer extends React.Component{

	constructor(props){
        super(props);
    }

    render(){

        var playerUSN = (this.props.player && this.props.player.USN) ? this.props.player.USN : null;
        var ROWPOS = (this.props.player && this.props.player.ROWPOS) ? parseInt(this.props.player.ROWPOS,10) : 0;
        var nick = (this.props.player && this.props.player.nick) ? this.props.player.nick : null;
        var currentUserUSN = (this.props.usn) ? this.props.usn : null;

        const LB_FINAL_DATE_FORMAT = window._region === 'BR' ? 
            "DD-MM-YYYY HH:mm:ss" : "YYYY-MM-DD HH:mm:ss";
        var myDate = (this.props.player 
            && this.props.player.last_Item_Date) ? 
                moment(
                    this.props.player.last_Item_Date, 
                    LB_API_RSLT_DATE_FORMAT
                ).format(LB_FINAL_DATE_FORMAT) :
                null;

        var collectionsLink = '/collections/';
        var cid = (this.props.cid) ? this.props.cid : null;

        var nameString = (this.props.currentUser) 
                        ? nick
                        : <a target="_self" href={generatePage_no_USN_URI(playerUSN)}>{nick}</a>;

        var rankClassToUse = styles.collectionRankBox;

        switch(ROWPOS){
            case 1: {
                rankClassToUse += ' ' + styles.collectionRankBox1
            }break;
            case 2: {
                rankClassToUse += ' ' + styles.collectionRankBox2
            }break;
            case 3: {
                rankClassToUse += ' ' + styles.collectionRankBox3
            }break;
        }

        //if(this.props.currentUser){
        //    rankClassToUse = styles.collectionRankBoxUser;
        //}

        if(playerUSN){
            return(
                        <div key={ROWPOS} className={rankClassToUse}>
                            <div className={styles.collectionRank}>
                                <div><span>{ROWPOS}</span></div>
                            </div>
                            <div className={styles.collectionRankText}>
                                <div>
                                    <span className={styles.collectionHREF}>{nameString}</span>
                                    <span className={styles.collectionRankDate}>{myDate}</span>                            
                                </div>
                            </div>
                        </div>
            );
        }else{
            return(null);
        }
    }
}


class CollectionsLeadersViewer extends React.Component{

	constructor(props){
        super(props);
        
	    this.state = {
            outputList: []
            ,usn: this.props.usn
            ,collections: []
            //not needed anymore, delete when ready
            // ,collection: getcollectionID
            ,collectionInfo: null
            ,top3Leaders: null
            ,restOfLeaders: null
            ,currentUser: null
            ,userSignedIn: false
            ,contentReady: false
            ,errorData: <div><Trans>No data to display</Trans></div>
            ,pageStatus: true
        }

        this.getLeaders();
        this.getSignedInPlayer();

    }

    getSignedInPlayer(){

        var apilink = weaponsAPI;


        var params = {};

        var _this = this;

        params.term = 'collectionRanking';
        params.usn = -1;
        params.collection_ID = this.props.cid; 

        axios({method: 'post', url: apilink, params})
        .then(function(response){
      
            if(response.data){

                //console.log(response.data);

                if(response.data.APIresult && '000' == response.data.APIresult
                   && response.data.User_Ranking
                   && response.data.APImessage && 'OK' == response.data.APImessage){

                    // last_Item_Date
                    // ranking
                    // NICK
                    // USN

                    // user has signed in if we get to this point

                    var currentUserData = (response.data.User_Ranking[0]
                        && response.data.User_Ranking[0].USN && response.data.User_Ranking[0].last_Item_Date
                        )
                        ? {     last_Item_Date : response.data.User_Ranking[0].last_Item_Date
                                ,ROWPOS : response.data.User_Ranking[0].ranking
                                ,nick: response.data.User_Ranking[0].NICK
                                ,USN: response.data.User_Ranking[0].USN
                          }
                        : null;

                        //console.log(currentUserData);

                    _this.setState({
                        currentUserData: currentUserData
                        ,userSignedIn: true
                    });                    
                }
            }
        })
        .catch(function(response){

            //console.log(response);

        })

    }

    getLeaders(){

        //console.log('getting collections')

        var apilink = profileAPI;

        var params = {};

        var _this = this;

        params.command = 'weaponcollectionleaders';
        params.usn = this.props.usn;
        //not needed anymore, delete when ready
        // params.collection = this.state.collection;
        params.collection = this.props.cid; 

      
        axios.get(apilink, {params: params})
          .then(function(response){
      
            if(response.data){

                if(response.data.APIresult && '000' == response.data.APIresult
                   && response.data.p_o_ErrID && '1' == response.data.p_o_ErrID
                   && !response.data.p_o_ErrDesc && response.data.dsCollectionLeaderboardResult 
                   && response.data.dsCollectionLeaderboardTotal && response.data.dsCollectionLeaderboardTotal[0]
                   && response.data.APImessage && 'OK' == response.data.APImessage){
        
                    //console.log('SUCCESS: retrieved user mode data');
                    //console.log(response.data.dsCollectionLeaderboardResult);
                    //console.log(response.data.dsCollectionLeaderboardTotal);

                    var collectionInfo = (response.data.dsCollectionInfo
                        && response.data.dsCollectionInfo[0]
                        && response.data.dsCollectionInfo[0].collection_Name
                       )
                       ? response.data.dsCollectionInfo[0]
                       : null;

                    if(!collectionInfo){
                        // abort
                        // go to error page
                        console.log('there was an error: perhaps this collection does not exist');
                    }else{
                        collectionInfo.total_CNT = response.data.dsCollectionLeaderboardTotal[0].total_CNT;
                    }

                    // current user data in dsCollectionLeaderboardUserInfo

                    var currentUserData = (response.data.dsCollectionLeaderboardUserInfo
                                    && response.data.dsCollectionLeaderboardUserInfo[0]
                                    && response.data.dsCollectionLeaderboardUserInfo[0].nick
                                    )
                                    ? response.data.dsCollectionLeaderboardUserInfo[0]
                                    : null;

                  _this.setState({
                      collectionInfo: collectionInfo
                      //,currentUserData: currentUserData
                      ,top3Leaders:         response.data.dsCollectionLeaderboardResult.slice(0,3)
                      ,top3LeadersData:         response.data.dsCollectionLeaderboardResult.slice(0,3)
                      ,restOfLeadersData:   response.data.dsCollectionLeaderboardResult.slice(3)
                      ,contentReady: true
                  });

                }else{
                  //console.log('FAIL: could not retrieve data due to \'not OK\' repsponse');
                    _this.setState({
                        collectionInfo: null
                        //,currentUserData: null
                        ,top3Leaders: null
                        ,restOfLeaders: null
                        ,currentUser: null
                        ,contentReady: false
                        ,pageStatus: false
                    });
                }
              }else{
                //console.log('FAIL: could not retrieve details');
                  _this.setState({
                    collectionInfo: null
                    //,currentUserData: null
                    ,top3Leaders: null
                    ,restOfLeaders: null
                    ,currentUser: null
                    ,contentReady: false
                    ,pageStatus: false
                  });
              }
          })
          .catch(function (error){
                //console.log('FAIL: could not retrieve details');
                _this.setState({
                    collectionInfo: null
                    //,currentUserData: null
                    ,top3Leaders: null
                    ,restOfLeaders: null
                    ,currentUser: null
                    ,contentReady: false
                    ,pageStatus: false
                });
        });
    }

    render (){
        
        if(this.state.contentReady){
            var _this = this;
            var myCID = (this.props.cid) ? this.props.cid : null;
            var disclaimerText = 'Data displayed is updated every 24 hours';
            var headerTitleText = 'Leaderboards';
            var backToTitleText = 'Back to Collections';

            // this.state.collectionInfo
            // this.state.top3LeadersData
            // this.state.restOfLeaders

            var missing_img = `${CDN_URI}imgs/collections/collection-missing.png`;

            var leader1 = (this.state.top3LeadersData && this.state.top3LeadersData[0]) ? this.state.top3LeadersData[0] : null;
            var leader2 = (this.state.top3LeadersData && this.state.top3LeadersData[1]) ? this.state.top3LeadersData[1] : null;
            var leader3 = (this.state.top3LeadersData && this.state.top3LeadersData[2]) ? this.state.top3LeadersData[2] : null;

            var showSignInBox   = (this.state.top3LeadersData && this.state.top3LeadersData.length) 
                                ? <CurrentPlayerInfoBox signedIn={this.state.userSignedIn} player={this.state.currentUserData} />
                                : null;

            var followers = (this.state.restOfLeadersData && this.state.restOfLeadersData.length) ? this.state.restOfLeadersData.map(function (leader) {

                return (
                            <Grid item xs={12} sm={6} md={6} lg={4} xl={4}  key = {leader.ROWPOS}>
                                <RankedPlayer player = {leader}  key = {leader.ROWPOS} cid={myCID} usn={_this.props.usn} />
                            </Grid>
                        );
            })
            : null;

            var allLeaders =    <Translation>
                                    {
                                    (t) =>
                                    <div style={{width: '100%'}}>
                                        <div className={styles.collectorLeadersContainer}>
                                            <Grid container item xs={12} spacing={3} style={{margin: '0px'}}>
                                                <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
                                                    <div className={styles.collectorLeaderBoxImage}>
                                                        <ReactImageFallback
                                                            src={this.state.collectionInfo.collection_Image}
                                                            fallbackImage={missing_img}
                                                            alt="collection img"
                                                            width="108px"
                                                            height="108px"
                                                        />
                                                    </div>

                                                    <div className={styles.collectorLeaderBoxHeader}>{this.state.collectionInfo.collection_Name}</div>                        

                                                    <div className={styles.collectorLeaderBoxNum}>{this.state.collectionInfo.total_CNT}</div>

                                                </Grid>

                                                {showSignInBox}

                                            </Grid>

                                            <Grid container item xs={12} spacing={3} style={{margin: '0px'}}>
                                                <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
                                                    <RankedPlayer player = {leader1} cid={myCID} />
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
                                                    <RankedPlayer player = {leader2} cid={myCID} />
                                                </Grid>                                        
                                                <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
                                                    <RankedPlayer player = {leader3} cid={myCID} />
                                                </Grid>
                                            </Grid>
                                        </div>

                                        {followers && <div className={styles.collectorFollowersContainer}>
                                            <Grid container item xs={12} spacing={3} style={{margin: '0px'}}>
                                                {followers}
                                            </Grid>
                                        </div>}
                                        <div className={styles.disclaimer}>{t(disclaimerText)}</div>
                                    </div>
                                }
                                </Translation>;
                                    
            var collectionsLeadersChild =   <div className={styles.collections} container spacing={2}>
                                                {allLeaders}
                                            </div>;

        }else{

            var collectionsLeadersChild =   <div className={styles.collections}>
                                                <div className={styles.collectorLeadersContainer}>
                                                    <Grid container item xs={12} spacing={3}>
                                                        <Grid item xs={8}>
                                                            <div className={styles.collectorLeaderBoxImage}>
                                                                <Skeleton variant="circle" width="108px" height="108px" style={{marginLeft: '20px'}} />
                                                            </div>

                                                            <div className={styles.collectorLeaderBoxHeader}>
                                                                <Skeleton height={3} width="50%" style={{marginLeft: '150px'}} />
                                                            </div>                        

                                                            <div className={styles.collectorLeaderBoxNum}>
                                                                <Skeleton height={3} width="30%"  style={{marginLeft: '160px'}} />
                                                            </div>

                                                        </Grid>
                                                        <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                                                            <Skeleton height={3} width="80%"/>
                                                            <Skeleton height={3} width="80%"/>
                                                            <Skeleton height={3} width="80%"/>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid container item xs={12} spacing={3}>
                                                        <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                                                            <Skeleton height={3} width="80%"/>
                                                            <Skeleton height={3} width="80%"/>
                                                            <Skeleton height={3} width="80%"/>
                                                        </Grid>
                                                        <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                                                            <Skeleton height={3} width="80%"/>
                                                            <Skeleton height={3} width="80%"/>
                                                            <Skeleton height={3} width="80%"/>
                                                        </Grid>                                        
                                                        <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                                                            <Skeleton height={3} width="80%"/>
                                                            <Skeleton height={3} width="80%"/>
                                                            <Skeleton height={3} width="80%"/>
                                                        </Grid>
                                                    </Grid>
                                                </div>
                                            </div>;

        }

        return (
            <Translation>
            {
            (t) =>
            <SubPageTemplate
                title={t('Leaderboards of Collection - Crossfire Player Profile')}
                headerData={this.props.headerData}
                headingLeft = {t(headerTitleText)}
                backToText={t(backToTitleText)}
                backToURL={generatePageURI(
                    pagePaths.COLLECTONS
                )}
            >
                {!this.state.pageStatus ? <Redirect to={`${prefixURI}/error`} /> : null}
                {collectionsLeadersChild}
            </SubPageTemplate>
        }
        </Translation>
        );        
    }
}

export default function CollectionLeadersPage(props) {
    const { match, dev } = props;

    const cid = dev ? props.cid : match.params.cid;

    // const [usn, setUSN] = useState();
    const [headerData, setHeaderData] = useState();
    const [pageStatus, setPageStatus] = useState(true);
  
    const usn = match ? match.params.usn : null;

    // Similar to componentDidMount and componentDidUpdate:
    //
    // https://stackoverflow.com/questions/53120972/how-to-call-loading-function-with-react-useeffect-only-once
    useEffect(() => {
      //api call to set data will be used
      if (usn) {
        axios.get(`${headerAPI}&usn=${usn}`).then(res => {
          if(res.data.p_o_ErrID === 1)            
            setHeaderData(res.data.dsProfileHeaderInfo[0]);
          else
            setPageStatus(false);
        });
      }
    }, []);
    return (
        <div>
        {!pageStatus ? <Redirect to={`${prefixURI}/error`} /> : null}
        <CollectionsLeadersViewer headerData={headerData} usn={usn} cid={cid} />
        </div>
    );


}
